import script from "./summary_one.vue?vue&type=script&setup=true&lang=js"
export * from "./summary_one.vue?vue&type=script&setup=true&lang=js"

import "./summary_one.vue?vue&type=style&index=0&id=2b05c05d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b05c05d"]])

export default __exports__